import script from "./ProviderThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./ProviderThumbnail.vue?vue&type=style&index=0&id=f6506418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6506418"]])

export default __exports__